<template>
  <div
    v-bind:class="[bgColor, 'section-container', 'font-family']"
    bg-color="bg-white"
    tabindex="-1"
    id="help-top"
    ref="helpscroll"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const el = this.$refs.helpscroll;
    if (el) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
      const topElement = document.getElementById('help-top');
      if (topElement) {
        topElement.focus();
      }
    }
  },
};
</script>

<style scoped>
.section-container {
  padding: 16px;
  padding-bottom: 50px;
  counter-reset: form-counter;
}
</style>
